import _ from 'lodash';
import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import SimulatorViewModel from '../../../../core/features/simulator/viewmodels/SimulatorOfficialViewModel';


export default {
    extends: ListComponent,
    data() {
        return {
            modulePermissions: 'SimulatorContent-Simulators',
            item: null,
            searchName: null,
            searchCode: null,
            viewModel: null,
            courseCategoryFilter: '',
            courseCategories: [],
            limit: 12,
            isSubscribed: false,
            modalImport: {
                isVisible: false,
                isLoading: false,
                title: 'IMPORTAR CURSOS',
                onUploadImport: 'onUploadImportSimulator',
                onCancelImport: 'onCancelImportSimulator'
            },
            studentInfoItem: null,
            modalSubscriptionInfo: {
                isVisible: false,
                isLoading: false,
            },
        }
    },
    created() {
        this.viewModel = new SimulatorViewModel(this);
        EventBus.$on('update-session', this.onUpdateSession);
        this.onActive();
    },
    mounted() {
        EventBus.$on('onSubmitedSimulator', this.onSearch);
        EventBus.$on('onUploadImportSimulator', this.onUploadImport);
        EventBus.$on('onCancelImportSimulator', this.onCancelImport);
    },
    beforeDestroy() {
        EventBus.$off('update-session', this.onUpdateSession);
        EventBus.$off('onSubmitedSimulator', this.onSearch);
        EventBus.$off('onUploadImportSimulator', this.onUploadImport);
        EventBus.$off('onCancelImportSimulator', this.onCancelImport);
    },
    methods: {
        onActive() {
            this.onSearch();
        },
        onSearch() {
            this.showLoading(true, 'Actualizando registros...');
            this.viewModel.findPublished();
        },
        onAllFilterChange(data, field) {
            this.onFilterChange(data, field);
        },
        onCanCreate() {
            return this.canCreate(this.modulePermissions)
        },
        onCanRead() {
            return this.canRead(this.modulePermissions)
        },
        onCanUpdate() {
            return this.canUpdate(this.modulePermissions)
        },
        onCanDelete() {
            return this.canDelete(this.modulePermissions)
        },
        getCoverImage(url) {
            return (url) ? url : '/images/courses/add_img.jpg'
        },
        onUpdateSession(data) {
            if (data.user.hasSubscriptions && !data.user.hasSubscriptionInfo) {
                this.studentInfoItem = this.viewModel.onCreateStudentInfo()
                this.viewModel.showModal(this.modalSubscriptionInfo, true)
            }
            this.isSubscribed = data.user.isSubscribed;
        },
        isCollectionEmpty(collection) {
            return _.isEmpty(collection)
        },
        isValidateSubscrition(url) {
            if(this.isSubscribed) {
                this.$router.push(url)
            } else {
                this.$confirm(`Tu suscripcion esta vencida. Para poner tu suscripción al día, accede al apartado Cuenta, en la opción de subscripción.`, 'Información', {
                    confirmButtonText: 'Aceptar',
                    type: 'warning',
                    confirmButtonClass:'btn-primary',
                    showCancelButton: false,
                })
                .then(() => {})
                .catch(() => {});
                return false;
            }
        }
    },
    computed: {}
}